var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { encountersService } from 'ziphy-web-shared/basic/api';
import { Loader } from 'ziphy-web-shared/basic/lib/loaders';
import { $notes } from '@nedoShared/modules/notes/Notes.store';
import AuditLog from '@nedoShared/modules/notes/ui/sidebarContent/auditLog/AuditLog';
const ICONS_MAP = {
    unlock: 'lockOpened',
    lock: 'lockClosed',
    sign: 'pen',
    cosign: 'pen',
    view: 'eye',
    addendum: 'plus',
};
export const EncounterAuditLog = () => {
    const [logs, setLogs] = useState([]);
    const [totalLogs, setTotalLogs] = useState(0);
    const [lastBatchId, setLastBatchId] = useState('');
    const [loadingKey, setLoadingKey] = useState(null);
    const fetchLogs = (lastId) => __awaiter(void 0, void 0, void 0, function* () {
        if (!logs.length) {
            setLoadingKey('initial');
        }
        else {
            setLoadingKey('nextBatch');
        }
        const lastIdParam = lastId ? { last_id: lastId } : undefined;
        const logsResponse = yield encountersService.getAuditLog(Object.assign({ id: $notes.encounterInfo.id, limit: 10 }, lastIdParam));
        if (!logsResponse.error) {
            const preparedLogs = logsResponse.prepared.encounterAuditlogs.items.map((log, index) => {
                return {
                    title: log.message,
                    subtitle: `by ${log.actor} (${log.role})`,
                    date: log.created,
                    iconType: ICONS_MAP[log.action],
                };
            });
            setLogs((prevLogs) => [...prevLogs, ...preparedLogs]);
            setLastBatchId(logsResponse.prepared.lastId);
            setTotalLogs(logsResponse.prepared.total);
        }
        setLoadingKey(null);
    });
    const fetchNextBatch = () => {
        if (lastBatchId)
            fetchLogs(lastBatchId);
    };
    useEffect(() => {
        fetchLogs(null);
    }, []);
    if (loadingKey === 'initial') {
        return _jsx(Loader, {});
    }
    const canLoadMore = Boolean(lastBatchId);
    return (_jsx(AuditLog, { logs: logs, total: totalLogs, canLoadMore: canLoadMore, loadMore: fetchNextBatch, isNextBatchLoading: loadingKey === 'nextBatch' }));
};
